import * as InboxActions from "./inboxActions";

export default InboxActions;



// WEBPACK FOOTER //
// ./src/actions/InboxActions/index.js